export enum GatewayType {
    PCS = "PCS",
    PSU = "PSU",
    POE = "POE",
    LoRaWAN = "LoRaWAN",
}

export const GATEWAY_SELECTION_TYPES = {
    IOTPORTAL: "IoTPortal Gateway",
    LORAWAN: "LoRaWAN Node",
} as const;

export const GATEWAY_ROUTES = {
    IOTPORTAL_ADD: "/gateways-add",
    LORAWAN_ADD: "/lorawan-add",
    GATEWAYS_ALL: "/gateways-all",
} as const;

export enum SensorType {
    EnergyConsumption,
    WaterConsumption,
}

// Actuator activation states
export const ACTIVATE = "activated";
export const DEACTIVATE = "deactivated";
